const C = (e) => Array.isArray(e) ? e : [e], A = (e, t, n, s = 0, i = 100) => (e - t) * (i - s) / (n - t) + s, D = (e, t) => Array.from(
  { length: Math.ceil(e.length / t) },
  (n, s) => e.slice(s * t, s * t + t)
), S = (...e) => e[0].map((t, n) => e.slice(1).reduce((s, i) => [...s, i[n]], [t])), F = (e) => e.length === 2 ? e : [null, ...e], I = (e) => e.reduce((t, [n, s], i) => (i === e.length - 1 ? t.push([[n, null], s]) : t.push([[n, e[i + 1][0]], s]), t), []), d = (e, t = {}) => {
  const { classes: n, styles: s, attributes: i, events: c, content: o, appendTo: a } = t, r = document.createElement(e);
  return n && C(n).forEach((l) => r.classList.add(l)), s && Object.entries(s).forEach((l) => r.style.setProperty(...l)), i && Object.entries(i).forEach(([l, h]) => {
    h || h === 0 ? r.setAttribute(l, `${h}`) : r.removeAttribute(l);
  }), c && Object.entries(c).forEach(([l, h]) => r.addEventListener(l, h)), o && r.append(...C(o).filter(Boolean)), a && a.appendChild(r), r;
}, _ = (e, t) => {
  const { labels: n = {}, unit: s = "" } = t || {};
  return Array.isArray(e) ? n[`${e}`] ?? (e[0] === null ? `< ${n[`${e[1]}`] || `${e[1]}${s}`}` : e[1] === null ? `> ${n[`${e[0]}`] || `${e[0]}${s}`}` : e.map((i) => n[`${i}`] || `${i}${s}`).join(" - ")) : e !== null ? n[`${e}`] ?? `${e}${s}` : n.other ?? "other";
}, x = {}, v = (e, t, n) => {
  const { getter: s } = e;
  t.id in x || (x[t.id] = t.filter ?? null);
  const i = (o, a) => {
    const { delta: r = 0 } = a || {};
    if (s)
      if (o == null) n.setFilter(t.id, x[t.id]);
      else if (Array.isArray(o)) {
        const [l, h] = o, p = l ? [">=", s, l] : !0, g = h ? ["<", s, h] : !0;
        n.setFilter(t.id, ["all", p, g]);
      } else {
        const l = typeof o == "number" ? ["all", [">=", s, o - r], ["<=", s, o + r]] : ["==", s, o];
        n.setFilter(t.id, l);
      }
  };
  return { highlight: i, events: (o) => ({
    mouseenter: () => i(o),
    mouseleave: () => i(void 0)
  }) };
}, j = { x: 0 }, T = (e, t, n, s) => {
  const { inputs: i, stops: c, min: o, max: a } = e, { highlight: r } = v(e, t, n), l = (a - o) / 100, h = {
    mouseleave: () => r(void 0),
    mousemove: (g) => {
      const { offsetX: f, target: m } = g;
      j.x = f;
      const u = m, y = A(f, 0, u.offsetWidth, o, a);
      r(y, { delta: l }), u.style.setProperty("--x", `${f}px`);
    }
  }, p = c.map(([g, f]) => `${f} ${A(g, o, a)}%`);
  return d("div", {
    classes: ["gradient", `gradient--${s.highlight ? "highlight" : ""}`],
    content: [
      d("p", {
        classes: "labels",
        content: i.map((g) => {
          const f = _(g, t.metadata);
          return f && d("span", {
            styles: { left: `${A(g, o, a)}%` },
            content: f
          });
        })
      }),
      d("div", {
        classes: "bar",
        styles: {
          "background-image": `linear-gradient(90deg, ${p})`,
          "--x": `${j.x || 0}px`
        },
        events: s.highlight ? h : {}
      })
    ]
  });
}, q = (e, t, n, s) => {
  const { stops: i } = e, { events: c } = v(e, t, n);
  return d("ul", {
    classes: ["list", "list--color", `list--${s.highlight ? "highlight" : ""}`],
    content: i.map(([o, a]) => {
      const r = _(o, t.metadata);
      return r && d("li", {
        styles: { "--color": a },
        events: s.highlight ? c(o) : {},
        content: r
      });
    })
  });
}, R = (e, t, n, s) => {
  switch (e.name) {
    case "interpolate":
      return T(e, t, n, s);
    case "match":
    case "step":
    case "literal":
      return q(e, t, n, s);
    default:
      return;
  }
}, U = (e, t, n, s) => {
  const { stops: i } = e, { events: c } = v(e, t, n);
  return d("ul", {
    classes: ["bubbles", `bubbles--${s.highlight ? "highlight" : ""}`],
    content: i.sort((o, a) => a[1] - o[1]).map(([o, a]) => {
      const r = _(o, t.metadata);
      return r && d("li", {
        styles: { "--radius": `${a}px` },
        events: s.highlight ? c(o) : {},
        content: d("span", {
          content: r
        })
      });
    })
  });
}, M = (e, t, n, s) => {
  const { stops: i } = e, { events: c } = v(e, t, n);
  return d("ul", {
    classes: ["list", "list--icons", `list--${s.highlight ? "highlight" : ""}`],
    content: i.map(([o, a]) => {
      var y;
      const r = _(o, t.metadata);
      if (!r) return;
      const { height: l, width: h, data: p } = ((y = n.style.getImage(a)) == null ? void 0 : y.data) || {};
      if (!l || !h || !p) return;
      const g = Math.max(h, l), f = d("canvas", {
        attributes: { width: g, height: g }
      }), m = f.getContext("2d"), u = new ImageData(Uint8ClampedArray.from(p), h, l);
      return m == null || m.putImageData(u, (g - h) / 2, (g - l) / 2), d("li", {
        events: s.highlight ? c(o) : {},
        content: [
          d("img", {
            classes: ["icon"],
            attributes: { src: f.toDataURL() }
          }),
          r
        ]
      });
    })
  });
}, N = { color: R, radius: U, image: M, pattern: M }, E = (e, t) => D(e.slice(t), 2), L = {
  interpolate: (e) => E(e, 2),
  match: (e) => E(e, 1).map(F),
  step: (e) => I([[null, e[1]], ...E(e, 2)]),
  literal: (e) => [[...e, ...e]]
}, O = (e) => Array.isArray(e) && !!e.length && typeof e[0] == "string", P = (e) => {
  var l;
  const [t, ...n] = O(e) ? e : ["literal", e];
  if (t === "case") return n.slice(1).flatMap(P);
  const s = (l = L[t]) == null ? void 0 : l.call(L, n);
  if (!s) return [];
  const i = t === "literal" ? void 0 : ["match", "step"].includes(t) ? n[0] : n[1], [c, o] = S(...s), a = Math.min(...c.flat(2)), r = Math.max(...c.flat(2));
  return [{ name: t, getter: i, stops: s, inputs: c, outputs: o, min: a, max: r }];
}, W = { isExpression: O, parse: P }, X = {
  collapsed: !1,
  toggler: !1,
  highlight: !1
};
class H {
  constructor(t) {
    const { layers: n, ...s } = t || {};
    this._options = { ...X, layers: void 0, ...s }, n && this.addLayers(n), this._panes = d("div", {
      classes: "panes",
      styles: { display: (t == null ? void 0 : t.minimized) ?? !1 ? "none" : "block" }
    }), this._minimizer = (t == null ? void 0 : t.minimized) !== void 0 ? d("button", {
      classes: "minimizer",
      events: {
        click: () => {
          const { display: i } = this._panes.style;
          this._panes.style.display = i === "none" ? "block" : "none";
        }
      }
    }) : void 0, this._container = d("div", {
      classes: ["mapboxgl-ctrl", "maplibregl-ctrl", "mapboxgl-ctrl-legend"],
      content: [this._minimizer, this._panes]
    }), this.refresh = this.refresh.bind(this);
  }
  onAdd(t) {
    return this._map = t, this._map.on("styledata", this.refresh), this._container;
  }
  onRemove() {
    var t, n;
    (t = this._container.parentNode) == null || t.removeChild(this._container), (n = this._map) == null || n.off("styledata", this.refresh);
  }
  addLayers(t) {
    var s, i;
    const n = (c, o) => {
      var g;
      const {
        collapsed: a = this._options.collapsed,
        toggler: r = this._options.toggler,
        highlight: l = this._options.highlight,
        onToggle: h = this._options.onToggle,
        attributes: p
      } = o || {};
      (g = this._options.layers) == null || g.set(c, { collapsed: a, toggler: r, highlight: l, onToggle: h, attributes: p });
    };
    (s = this._options).layers ?? (s.layers = /* @__PURE__ */ new Map()), Array.isArray(t) ? t.forEach((c) => n(c)) : Object.entries(t).forEach(([c, o]) => {
      typeof o == "boolean" ? n(c) : Array.isArray(o) ? n(c, { attributes: o }) : n(c, o);
    }), (i = this._map) != null && i.isStyleLoaded() && this.refresh();
  }
  removeLayers(t) {
    t.forEach((n) => {
      var i;
      (i = this._options.layers) == null || i.delete(n);
      const s = this._panes.querySelector(`.mapboxgl-ctrl-legend-pane--${n}`);
      s && this._panes.removeChild(s);
    });
  }
  _getBlocks(t, n, s, i) {
    var l;
    const [c] = s.split("-").slice(-1), o = N[c];
    if (!o) return;
    const a = W.parse(i), r = ((l = this._options.layers) == null ? void 0 : l.get(t)) || this._options;
    return a.map((h) => o(h, n, this._map, r)).filter(Boolean);
  }
  _toggleButton(t, n) {
    var o, a;
    const { onToggle: s = this._options.onToggle } = ((o = this._options.layers) == null ? void 0 : o.get(n)) || {}, i = ((a = this._map) == null ? void 0 : a.getLayoutProperty(t[0], "visibility")) || "visible", c = d("div", { classes: ["toggler", `toggler--${i}`] });
    return c.addEventListener("click", (r) => {
      r.preventDefault();
      const l = i === "none" ? "visible" : "none";
      t.forEach((h) => {
        var p;
        (p = this._map) == null || p.setLayoutProperty(h, "visibility", l), s == null || s(h, l === "visible");
      });
    }), c;
  }
  refresh() {
    var n;
    const t = [...((n = this._options.layers) == null ? void 0 : n.keys()) || []];
    this._map.getStyle().layers.filter((s) => s.source && s.source !== "composite").filter((s) => !this._options.layers || t.some((i) => typeof i == "string" ? s.id === i : s.id.match(i))).reverse().forEach((s) => {
      var k;
      const { id: i, layout: c, paint: o, metadata: a } = s, r = t.find((b) => i.match(b)) || i, { collapsed: l, toggler: h, attributes: p } = ((k = this._options.layers) == null ? void 0 : k.get(r)) || this._options, g = Object.entries({ ...c, ...o }).reduce((b, [B, w]) => {
        if (!((p == null ? void 0 : p.includes(B)) ?? !0)) return b;
        const $ = this._getBlocks(r, s, B, w);
        return $ == null || $.forEach((z) => b.push(z)), b;
      }, []);
      if (!g.length) return;
      const f = `mapboxgl-ctrl-legend-pane--${i}`, m = this._panes.querySelector(`.${f}`), u = h ? typeof h == "boolean" ? [i] : h : void 0, y = d("details", {
        classes: ["mapboxgl-ctrl-legend-pane", f],
        attributes: { open: m ? m.getAttribute("open") !== null : !l },
        content: [
          d("summary", {
            content: [
              (a == null ? void 0 : a.name) || i,
              u && this._toggleButton(u, r)
            ]
          }),
          ...g
        ]
      });
      m ? this._panes.replaceChild(y, m) : this._panes.appendChild(y);
    });
  }
}
export {
  H as default
};
